import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Star3Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 1L11.9091 11.9091L1 16L11.9091 20.0909L16 31L20.0909 20.0909L31 16L20.0909 11.9091L16 1Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
